import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ValidationService } from '../../../core/service/validation.service';

@Component({
  selector: 'app-control-message',
  templateUrl: './control-message.component.html',
  styleUrls: ['./control-message.component.scss']
})
export class ControlMessageComponent {
  @Input() message: string;
  @Input() control: UntypedFormControl;

  constructor(private validationService: ValidationService) {}

  isShowErrorMessage(): boolean {
    return this.errorMessage != null;
  }

  get errorMessage(): string {
    if (this.message) {
      return this.message;
    }
    if (this.control && this.control.errors) {
      for (const propertyName of Object.keys(this.control.errors)) {
        if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
          return this.validationService.getValidatorErrorMessage(propertyName);
        }
      }
    }
    return null;
  }
}
